module.exports = __webpack_public_path__ + "static/img/WPK000_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/WPK000_1.png
// module id = MGlT
// module chunks = 0